// extracted by mini-css-extract-plugin
export default {"packageTemplate":"IQfd6lDPQ7Qxa4C4NkxW4","actions":"_3Q8cY4K8uxWWHwfXLqHq1L"};